<template>
  <div>
    <h2 class="mb-6">Vielen Dank für Deine Büro-Bestellung ❤️</h2>
    <p>
      Deine Artikel wurden in den Warenkorb des Hauptbestellers gelegt.<br />
      Nachdem er die Bestellung abgeschickt hat, werden wir ihn in Kürze per SMS über den weiteren Verlauf der Bestellung informieren.<br />
      <span v-if="estimated">Die geschätze Lieferzeit beträgt aktuell etwa {{ estimated }} Minuten.<br /></span>
    </p>
    <p>Guten Appetit!</p>

    <div v-if="hasPayPalMeUrl" class="my-4 p-4 bg-grey-light rounded">
      <strong>Der Hauptbesteller bittet darum, dass du ihm die {{ this.orderValue | pricetag }} per PayPal zukommen lässt.</strong><br />
      <button @click="paypalMe()" class="shadow bg-green-heinz hover:bg-green-heinz-dark text-white font-bold mt-2 py-2 px-4 rounded">Geld per PayPal an @{{ payPalMeUrl }} senden</button>
    </div>

    <orderstatus v-if="officeOrderId" type="officeClient" :officeOrderId="officeOrderId" :officeOrderUid="officeOrderUid" class="mt-8" />

    <div v-if="!isLoggedIn" class="quickregistration my-8 bg-grey-lighter p-4 rounded border-l-4 border-green-heinz">
      <h2 v-if="!isLoggedIn" class="border-0 mb-0 pb-1">Du bist noch nicht bei foodi.de registriert?</h2>
      Melde dich in wenigen Sekunden an - es lohnt sich 🔥<br />
      <router-link tag="button" :to="{ name: 'Registrierung' }" class="shadow bg-green-heinz hover:bg-green-heinz-dark text-white font-bold mt-4 py-2 px-4 rounded">kostenlos Registrieren</router-link>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import OrderStatus from '../../components/OrderStatus.vue'
import axios from 'axios'
import endpoints from '../../endpoints'

export default {
  name: 'DankeBuero',

  data () {
    return {
      hostId: window.hostId,
      estimated: null,
      officeOrderId: null,
      officeOrderUid: null,
      payPalMeUrl: null,
      orderValue: 0
    }
  },

  components: {
    'orderstatus': OrderStatus
  },

  computed: {
    ...mapGetters([
      'isLoggedIn',
      'officeOrder'
    ]),

    hasPayPalMeUrl () {
      return this.payPalMeUrl && this.payPalMeUrl !== '' && this.orderValue > 0
    }
  },

  created () {
    this.officeOrderId = parseInt(this.officeOrder.officeOrderId)
    this.officeOrderUid = this.officeOrder.officeOrderUid
    this.getPaypalMeUrl()
  },

  methods: {
    ...mapMutations([
      'clearOfficeOrder'
    ]),

    getPaypalMeUrl () {
      axios.post(endpoints.getOfficeOrderPayPalMeAddress, {
        id: this.officeOrderId,
        uid: this.officeOrderUid
      })
        .then(({data}) => {
          this.clearOfficeOrder()

          if (data.success) {
            this.payPalMeUrl = data.payPalUrl
            this.orderValue = data.orderValue
          }
        })
    },

    paypalMe () {
      if (this.hasPayPalMeUrl) {
        window.open('https://www.paypal.me/' + this.payPalMeUrl + '/' + this.orderValue)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/confirmation/done-office.vue